// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-069e4efe]{max-width:400px}.banner[data-v-069e4efe]{background-color:#2a2a2a;height:90px;width:720px}.iframe-container[data-v-069e4efe]{padding-top:56.25%;position:relative}.iframe-design[data-v-069e4efe]{border:none;height:100%;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
